import { Fragment } from "react";
import { Flex, Text, Input } from "@theorgchartdev/storybook";
import {
  sectionContainer,
  sectionTitles
} from "../../../../Navigation/Header/WebLinkMenu/WebLinkUtils";
import { appstr } from "@coreapp/utils/appstr";

export const ParametersSection = ({ currentParams, setUrlParamsMgr }) => {
  const SetParameters = value => {
    setUrlParamsMgr(prevState => ({ ...prevState, parameters: value }));
  };

  return (
    <Fragment>
      <Flex {...sectionContainer}>
        <Text size={"small"} modifier={"bold"}>
          {appstr(sectionTitles.params)}
        </Text>
        <Input
          id={"weblink-param-input"}
          dataTestId={"weblink-param-input"}
          value={currentParams}
          size={"small"}
          onChange={e => SetParameters(e.target.value)}
          placeholder={appstr("This is not normally required")}
        />
      </Flex>
    </Fragment>
  );
};
